import styled from '@emotion/styled';
import { ComponentProps as InputItemProps } from './OptionInputItem';

export const SearchContainer = styled.div<any>`
  position: relative;
  ${(props) => !props.searchable && 'cursor: pointer;'}
  input {
    ${(props) => !props.searchable && 'cursor: pointer;'}
  }
  > div {
    ${(props) => props.autoHeight && 'max-height: fit-content; padding: 0.563em 6px;'}
  }
  > div {
    ${(props) => props.disabled && 'color: var(--color-indigo);'}
  }
  ${(props) => props.disabled && 'pointer-events: none;'}
`;

export const DroplistContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 999;
  padding-top: 8px;
`;

export const InputItem = styled.div<Partial<InputItemProps>>`
  padding-left: ${(p) => (p.mode === 'secondary' ? '0px;' : '6px;')};
  font-size: 16px;
  line-height: 26px;
  display: flex;
  overflow: hidden;
  max-width: calc(100% - 20px);
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Loader = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  border: 0.2em solid var(--color-indigo-t2);
  border-top: 0.2em solid var(--color-indigo-t5);
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  animation: spin 0.6s linear infinite;
`;
